// generated file, if you want to edit this file manually change the word "generated" to "manual"

import { makeThemedStyles } from '@qpr/components/utils';
import clsx from 'clsx';
import React from 'react';

const useStylesForSeparatorLine = makeThemedStyles('SeparatorLine', () => ({
  SeparatorLine: {
    background: '#b6ced0',
    width: '1px',
    height: '80%',
    paddingBottom: '1em',
    paddingTop: '1em'
  }
}));

type ElementProps = React.ComponentProps<React.HTMLFactory<HTMLElementTagNameMap['div']>>;

export const SeparatorLine: React.FunctionComponent<ElementProps> = (props: ElementProps) => {
  const styles = useStylesForSeparatorLine();

  /* eslint-disable */
  return (
    <div
      {...props}
      style={{ ...(props?.style || {}), ...{} }}
      className={clsx(styles.SeparatorLine)}
    />
  );
};
export default SeparatorLine;
